import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsLprFilterPlateAttributes extends SnModel {
  @Expose()
  public subdivisions: string[];

  @Expose()
  public types: string[];

  constructor(data = {}) {
    super();
    this.fromJSON(data);
  }
}
